import { store } from '../../app/store';
import { isDevEnvironment } from './appUtils';
import {
  ErrorResponseFromJSON,
  instanceOfErrorResponse,
  instanceOfValidationErrorResponse,
  ResponseError,
  ValidationErrorResponseFromJSON
} from '../../generated/api';

export const getJwtAccessToken = () => {
  const state = store.getState();
  const token = state.auth.admin.token?.access;

  return token ?? null;
};

export const getApplicantCode = () => {
  const state = store.getState();
  const code = state.auth.applicant?.code;

  return code ?? null;
};

export const getApiBaseUrl = () => {
  if (isDevEnvironment()) {
    return 'http://127.0.0.1:8000';
  } else {
    return window.location.origin;
  }
};

export const getMessageFromError = async (error: unknown): Promise<string> => {
  try {
    if (!(error instanceof ResponseError)) return String(error);
    const errorResponse = await error.response.text();
    const errorObject = JSON.parse(errorResponse);

    if (instanceOfErrorResponse(errorObject)) {
      return ErrorResponseFromJSON(errorObject).detail;
    }
    if (instanceOfValidationErrorResponse(errorObject)) {
      return Object.entries(ValidationErrorResponseFromJSON(errorObject).errors)
        .map(([key, value]) => `${key}: ${value}`)
        .join('\r\n');
    }
    return String(errorResponse);
  } catch (e) {
    return String(e);
  }
};
